module.exports = __webpack_public_path__ + "img/29.2a36565f.jpg";